


























import Header from "@/components/header/Header.vue";
import DeviceCollection from "@/components/portfolio/DeviceCollection.vue";
import {PortfolioProject} from "@/components/portfolio/PortfolioProject.ts";
import stringsKeys from "@/i18n/strings.json";

export default {
  name: 'PortfolioScreenMotto',
  components: {
    Header,
    DeviceCollection
  },
  props: {
    project: {
      type: Object as () => PortfolioProject,
      required: true
    }
  },
  data: () => {
    return {
      locale: stringsKeys,
    }
  }
}
